import { combineReducers } from 'redux';
import produce from 'immer';
import { WorkspaceKeysActionType, WorkspaceKeysAction } from '../../actions/workspaceKeyActions';

const loading = (state = false, action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS:
      return true;
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS_OK:
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS:
      return '';
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS_ERROR:
      return action.error;
    default:
      return state;
  }
};

const creating = (state = false, action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY:
      return true;
    case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY_OK:
    case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY_ERROR:
      return false;
    default:
      return state;
  }
};

const createError = (state = '', action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY:
      return '';
    case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY_ERROR:
      return action.error;
    default:
      return state;
  }
};

const deletingAll = (state = false, action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS:
      return true;
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS_OK:
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS_ERROR:
      return false;
    default:
      return state;
  }
};

const deletingAllError = (state = '', action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS:
      return '';
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS_ERROR:
      return action.error;
    default:
      return state;
  }
};

type LoadingState = { loading: boolean; loadingError: string };
type DeletingState = { deleting: boolean; deletingError: string };
type EditingStates = { editing: boolean; editingError: string };

export type WorkspaceKeyState = LoadingState & DeletingState & EditingStates;

interface WorkspaceKeyStatesByKey {
  [key: string]: WorkspaceKeyState;
}

const byId = (state: WorkspaceKeyStatesByKey = {}, action: WorkspaceKeysAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case WorkspaceKeysActionType.GET_WORKSPACE_KEYS_OK: {
        action.data.forEach((workspaceKey) => {
          draft[workspaceKey.id] = {} as WorkspaceKeyState;
        });

        break;
      }
      case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY_OK: {
        draft[action.data.id] = {} as WorkspaceKeyState;
        break;
      }
      case WorkspaceKeysActionType.DELETE_WORKSPACE_KEY: {
        draft[action.keyId].deleting = true;
        draft[action.keyId].deletingError = '';
        break;
      }
      case WorkspaceKeysActionType.DELETE_WORKSPACE_KEY_OK: {
        delete draft[action.keyId];
        break;
      }
      case WorkspaceKeysActionType.DELETE_WORKSPACE_KEY_ERROR: {
        draft[action.keyId].deleting = false;
        draft[action.keyId].deletingError = action.error;
        break;
      }
      case WorkspaceKeysActionType.EDIT_WORKSPACE_KEY: {
        draft[action.keyId].editing = true;
        draft[action.keyId].editingError = '';
        break;
      }
      case WorkspaceKeysActionType.EDIT_WORKSPACE_KEY_OK: {
        draft[action.keyId].editing = false;
        break;
      }
      case WorkspaceKeysActionType.EDIT_WORKSPACE_KEY_ERROR: {
        draft[action.keyId].editing = false;
        draft[action.keyId].editingError = action.error;
        break;
      }
      case WorkspaceKeysActionType.GET_WORKSPACE_KEY: {
        draft[action.keyId].loading = true;
        draft[action.keyId].loadingError = '';
        break;
      }
      case WorkspaceKeysActionType.GET_WORKSPACE_KEY_OK: {
        draft[action.keyId].loading = false;
        draft[action.keyId].loadingError = '';
        break;
      }
      case WorkspaceKeysActionType.GET_WORKSPACE_KEY_ERROR: {
        draft[action.keyId].loading = false;
        draft[action.keyId].loadingError = action.error;
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  loading,
  loadingError,
  creating,
  createError,
  deletingAll,
  deletingAllError,
  byId,
});
